import { render, staticRenderFns } from "./OutStockOrderScan.vue?vue&type=template&id=384cfa8c&scoped=true&"
import script from "./OutStockOrderScan.vue?vue&type=script&lang=js&"
export * from "./OutStockOrderScan.vue?vue&type=script&lang=js&"
import style0 from "./OutStockOrderScan.vue?vue&type=style&index=0&id=384cfa8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384cfa8c",
  null
  
)

export default component.exports